import { ApiFeaturedListResponse } from "shared/types/selection/ApiSelectionFeaturedList";
import { BaseSystemGeneratedList } from "./Base";
import { Copies } from "shared/hooks/useCopies";
import ContextEntityType from "shared/enums/ContextEntityType";

export default class EmptySystemGeneratedList extends BaseSystemGeneratedList {
  getInitialValues(contextId: string, contextEntityType: ContextEntityType, data?: ApiFeaturedListResponse) {
    return {};
  }
  getValidationSchema(copies: Copies) {
    return {};
  }
}
